import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FileSizeModule } from '@portal-core/general/pipes/file-size/file-size.module';
import { FilePropertiesComponent } from './file-properties.component';


@NgModule({
  declarations: [
    FilePropertiesComponent
  ],
  imports: [
    CommonModule,
    FileSizeModule,
  ],
  exports: [
    FilePropertiesComponent
  ]
})
export class FilePropertiesModule { }
